import axios from 'axios';

import { v4 as uuidv4 } from 'uuid';
import { store } from '@/_store/store';
import { API_URL } from '../../env';
import {
  handleInterceptResponseError,
  _handleInterceptResponseSuccess,
} from './interceptors';

const apiClient = axios.create({
  baseURL: API_URL,
});

apiClient.interceptors.request.use(config => {
  if (config.headers) {
    config.headers.cid = uuidv4();
  }
  return config;
});

apiClient.interceptors.response.use(
  _handleInterceptResponseSuccess,
  handleInterceptResponseError,
);

export const setBearerToken = (token: string) => {
  apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

// TODO apos a finalizacao do uso do apiClientOld, nao deve precisar mais do interceptors.request
// usando apenas o setBearerToken
apiClient.interceptors.request.use(config => {
  const { token } = store.getState().auth;

  if (!token) {
    return config;
  }

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  return {
    ...config,
    headers: { ...config.headers, ...headers },
  };
});

export { apiClient };
